import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#1B7FC2] hover:underline mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
        <p className="text-gray-500 mb-8">Last updated: January 2026</p>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Information We Collect</h2>
            <p className="text-gray-700 leading-relaxed">
              InsiderPass collects the following information when you create an account:
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>Phone number (required for account verification)</li>
              <li>First and last name</li>
              <li>Email address (optional)</li>
              <li>Transaction history and points activity</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. How We Use Your Information</h2>
            <p className="text-gray-700 leading-relaxed">
              We use your information to:
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>Verify your identity via SMS verification codes</li>
              <li>Track your loyalty points and rewards</li>
              <li>Send you notifications about points earned, tier upgrades, and redemptions</li>
              <li>Provide customer support</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. SMS Messaging</h2>
            <p className="text-gray-700 leading-relaxed">
              By providing your phone number and opting in, you consent to receive SMS messages from InsiderPass including:
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>Verification codes for account access</li>
              <li>Points balance and rewards notifications</li>
              <li>Tier upgrade confirmations</li>
              <li>Redemption confirmations</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-3">
              Message frequency varies based on your activity, typically 2-10 messages per month.
              Message and data rates may apply. You can opt out at any time by replying STOP to any message.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Data Sharing</h2>
            <p className="text-gray-700 leading-relaxed">
              We share your information only with:
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>The retail business whose loyalty program you joined (e.g., BuggyBusters)</li>
              <li>Service providers who help us operate our platform (e.g., Twilio for SMS)</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-3">
              We do not sell your personal information to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Data Security</h2>
            <p className="text-gray-700 leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal
              information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Your Rights</h2>
            <p className="text-gray-700 leading-relaxed">
              You have the right to:
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>Access your personal information</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your account</li>
              <li>Opt out of SMS messages at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Contact Us</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at:{' '}
              <a href="mailto:support@insiderpass.io" className="text-[#1B7FC2] hover:underline">
                support@insiderpass.io
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Changes to This Policy</h2>
            <p className="text-gray-700 leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any changes
              by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </section>
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          © 2026 InsiderPass LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
}
